import * as React from 'react';
import { RouteComponentProps } from "react-router";
import { PluginTemplates } from "../utils/PluginTemplates";
import FalconHeader from "../components/navigation/FalconHeader";
import FalconFooter from "../components/navigation/FalconFooter";
import {FalconNavigatorHeader} from "@falcon/services";

interface IProps extends RouteComponentProps<{}> {
}

export class ContactUsPage extends React.Component<IProps> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Contact Us");
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>

                <div className="plugin">
                    <FalconNavigatorHeader back="/dashboard" title="Contact us"/>
                    <div className="panel inner-container">
                        <p>For any questions about your Allianz subscription or if you want to request paper documents, email our customer service team.</p>
                        <div className="email-icon-item"/>
                        <a className="contact-email-link long-word" href="mailto:customerrelations_flow@lv.co.uk" target="_blank" id="glCustomerSupport"
                           aria-label="Flow customer relations email address">customerrelations_flow@lv.co.uk</a>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>

                <FalconFooter/>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/ContactUsPage.tsx